import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components

// Banner Component: Displays a promotional banner for gardening and landscaping solutions
const Banner = () => {
  return (
    <section className="banner">
      <div className="content">
        
        {/* Heading component with title, subtitle, and linear styling */}
        <Heading 
          title={'Discover Exceptional Gardening and Landscaping Solutions'} 
          subTitle={'Enhance Your Outdoor Space'} 
          sideHeading 
          linear 
        />
        
        {/* Button component linking to the "Get A Quote" section */}
        <Button link={'GetQuote'} title={'Get A Quote'} /> 

      </div>
    </section>
  );
};

export default Banner;